import { render, staticRenderFns } from "./ztomIndex.vue?vue&type=template&id=824759fe&scoped=true&"
import script from "./ztomIndex.vue?vue&type=script&lang=js&"
export * from "./ztomIndex.vue?vue&type=script&lang=js&"
import style0 from "./ztomIndex.vue?vue&type=style&index=0&id=824759fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824759fe",
  null
  
)

export default component.exports